module.exports = __webpack_public_path__ + "img/uj_05.289941ce.jpg";